<template>
  <div class="dashboard bg-container-background !pt-0 !pb-2 px-0 rounded-xl !mt-0">
    <div class="h-[calc(100vh-84px)] overflow-y-auto relative scrollbar">
      <div
        v-if="hasMoreDashboards"
        class="!mb-3 sticky top-0 z-1 !pt-2 !rounded-t-xl bg-container-background"
      >
        <el-tabs
          id="dashboardTabs"
          v-model="activeCustomDashboardId"
          @tab-click="changePageDashboard"
          type="card"
        >
          <el-tab-pane
            v-for="(item, index) in pageDashboards"
            :key="index + item.id"
            :label="item.name"
            :name="item.id"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div
        class="dashboard"
        v-if="activeCustomDashboard"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div
          class="Greeting flex !flex-wrap items-start md:items-center justify-between !gap-3 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[4] !pt-3"
          v-if="!hasMoreDashboards"
        >
          <div
            class="!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
          >
            {{ activeCustomDashboard.name }}
          </div>
        </div>
        <div v-if="activeCustomDashboard">
          <el-row
            class="dashboard-filters"
            v-if="
              (activeCustomDashboard &&
                ((activeCustomDashboard.allCustomFilters &&
                  activeCustomDashboard.allCustomFilters.length) ||
                  activeCustomDashboard.includeGlobalDateFilter)) ||
              (activeCustomDashboard.allIntegrationFilters &&
                activeCustomDashboard.allIntegrationFilters.length)
            "
          >
            <div class="!px-4" :span="24">
              <CustomDashboardFilters
                v-if="dateFilter"
                :allDashboardstats="activeCustomDashboard"
                :getAllCompanyTemplatesData="allCompanyTemplatesData"
                :integrations="integrations"
                :integrationFilters="integration_filters"
                :allIntegrationGlobalFilters="allIntegrationGlobalFilters"
              ></CustomDashboardFilters>
            </div>
            <el-row
              v-if="
                activeCustomDashboard &&
                activeCustomDashboard.allStatComponents &&
                activeCustomDashboard.allStatComponents.length
              "
            >
              <el-col :span="24">
                <CustomDashboardStats
                  :getAllCompanyTemplatesData="allCompanyTemplatesData"
                  :getAllEntities="getAllEntities"
                  :allDashboardstats="activeCustomDashboard"
                  :hide_options="true"
                  :isFromApplicationuser="isFromApplicationuser"
                  :refresh="refresh"
                  :permissionsSet="permissionsSet"
                  :integrations="integrations"
                  :isIntegrationEdit="true"
                  @DateFilterUpdate="DateFilterUpdate"
                  :integrationFilters="integration_filters"
                ></CustomDashboardStats>
              </el-col>
            </el-row>
          </el-row>
          <el-row v-if="activeCustomDashboard">
            <div v-if="!activeCustomDashboard.allTableComponents.length && !hasDataTableStat">
              <el-empty description="No tables configured"></el-empty>
            </div>
            <div class="px-3 mt-3">
              <div class="wrapper-grid">
                <draggable
                  class="drag-grid px-0"
                  @end="switchPositions"
                  :disabled="!activeCustomDashboard.allowUserChangeOrder"
                >
                  <div
                    v-for="(component, index) in activeCustomDashboard.allTableComponents"
                    :key="component.entity_id + '_' + component.keyValue + '_table_' + index"
                    class="grid-item !bg-card-color shadow-none !rounded-xl !border border-solid !border-page-border overflow-hidden"
                    :class="{
                      'full-span':
                        expendedIndexs.includes(index) ||
                        getIsMobile ||
                        component.type === 'SCHEDULING',
                    }"
                  >
                    <CustomDashboardTable
                      v-if="component.type == 'TABLE'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :component="component"
                      :entity_id="component.entity_id"
                      :filter_id="component.filter_id"
                      :index="index"
                      :globalVariablesData="globalVariablesData"
                      @expendTable="expendTable"
                      :hide_options="true"
                      :permissionsSet="permissionsSet"
                      :hasViewPermission="checkPermissions(component.entity_id, 'VIEW')"
                      :hasEditPermission="checkPermissions(component.entity_id, 'EDIT')"
                      :isFromApplicationuser="isFromApplicationuser"
                    ></CustomDashboardTable>
                    <CustomDashboardPieChart
                      v-else-if="component.type == 'CHART'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :component="component"
                      :hide_options="true"
                      :index="index"
                      :isFromApplicationuser="isFromApplicationuser"
                      @expendTable="expendTable"
                      :hasViewPermission="checkPermissions(component.entity_id, 'VIEW')"
                      :hasEditPermission="checkPermissions(component.entity_id, 'EDIT')"
                      :integrations="integrations"
                      @updateCsutomDashboard="updateCsutomDashboard"
                      :isIntegrationEdit="true"
                      :integrationFilters="integration_filters"
                      :customDashboardData="activeCustomDashboard"
                    ></CustomDashboardPieChart>
                    <CustomDashboardCalendar
                      v-else-if="component.type == 'CALENDAR'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :component="component"
                      :index="index"
                      @expendTable="expendTable"
                      :hide_options="true"
                      :isFromApplicationuser="isFromApplicationuser"
                    ></CustomDashboardCalendar>
                    <CustomDashboardLogins
                      v-else-if="component.type == 'LOGINS'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :component="component"
                      :index="index"
                      @expendTable="expendTable"
                      :hide_options="true"
                      :isFromApplicationuser="isFromApplicationuser"
                    ></CustomDashboardLogins>
                    <EntityViews
                      v-else-if="component.type == 'ENTITY_VIEW'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :entityViewId="component.entity_view_id"
                      :fromCustomDashboard="true"
                      :index="index"
                      :component="component"
                      :hide_options="true"
                      @expendTable="expendTable"
                    ></EntityViews>
                    <CustomDashboardGaugeChart
                      v-else-if="component.type == 'GAUGE_CHART'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :component="component"
                      :index="index"
                      :hide_options="true"
                      @expendTable="expendTable"
                    ></CustomDashboardGaugeChart>
                    <CustomDashboardNotifications
                      v-else-if="component.type == 'NOTIFICATIONS'"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData"
                      :component="component"
                      :index="index"
                      :hide_options="true"
                      :isFromApplicationuser="isFromApplicationuser"
                    ></CustomDashboardNotifications>
                    <SchedulingEntity
                      v-else-if="component.type == 'SCHEDULING'"
                      :getAllEntities="[]"
                      :getAllCompanyTemplatesData="allCompanyTemplatesData.data || []"
                      :component="component"
                      :index="index"
                      :hide_options="true"
                    ></SchedulingEntity>
                  </div>
                </draggable>
              </div>
            </div>
          </el-row>
        </div>
        <div v-else>
          <el-empty description="No components configured"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { postAPICall } from '@/helpers/httpHelper';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  import draggable from 'vuedraggable';
  import templateBuilderHelper from '../../mixins/templateBuilderHelper';
  import { fetchGlobalVariables } from '@/repo/globalVariables';
  import { updateCustomDashboardData } from '@/repo/customDashboardRepo';
  import returnGlobalIntegrationFilters from '@/mixins/CustomDashboardHelper.js';
  export default {
    components: {
      CustomDashboardTable: () => import('@/components/customDashboard/customDashboardTable.vue'),
      CustomDashboardStats: () => import('@/components/customDashboard/customDashboardStats.vue'),
      CustomDashboardPieChart: () =>
        import('@/components/customDashboard/customDashboardPieChart.vue'),
      CustomDashboardFilters: () =>
        import('@/components/customDashboard/customDashboardFilters.vue'),
      CustomDashboardCalendar: () =>
        import('@/components/customDashboard/customDashboardCalendar.vue'),
      CustomDashboardLogins: () => import('@/components/customDashboard/customDashboardLogins.vue'),
      EntityViews: () => import('@/components/entity/EntityViews.vue'),
      draggable,
      CustomDashboardGaugeChart: () =>
        import('@/components/customDashboard/customDashboardGaugeChart.vue'),
      CustomDashboardNotifications: () =>
        import('@/components/customDashboard/customDashboardNotifications.vue'),
      SchedulingEntity: () => import('@/components/customDashboard/schedulerComponent.vue'),
    },
    data() {
      return {
        loading: false,
        globalVariablesData: [],
        integrations: [],
        activeCustomDashboard: null,
        activeCustomDashboardId: '',
        expendedIndexs: [],
        refresh: false,
        permissionsSet: {},
        isFromApplicationuser: false,
        allCompanyTemplatesData: {},
        getAllEntities: {},
        dateFilter: false,
        pageDashboards: [],
        loadingText: 'Gathering data, please wait...',
        currentMenuId: '',
        integration_filters: {},
      };
    },
    mixins: [MobileRelatedHelper, templateBuilderHelper, returnGlobalIntegrationFilters],
    computed: {
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getUserType',
        'getActiveContactType',
      ]),
      ...mapGetters('customDashboard', [
        'getUserDashboardsList',
        'getEntityUserDashboardsList',
        'getSingleDashboardData',
        'getPageDashboards',
        'getUpdateDashboardStatus',
        'getUpdateDashboardError',
      ]),
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      ...mapGetters('applicationUsersPermission', ['getEntityPermission']),
      ...mapGetters('paymentGateway', ['getPaymentsHistory', 'getPlansFeatures']),
      hasMoreDashboards() {
        return this.pageDashboards?.length > 1;
      },
      allIntegrationGlobalFilters() {
        return this.returnGlobalIntegrationFilters(this.activeCustomDashboard);
      },
    },
    mounted() {
      if (this.$route.name == 'application-user-page-dashboard') {
        this.isFromApplicationuser = true;
      }
      this.currentMenuId = this.$route?.query?.menu_id;
      this.getAllPageDashboards();
      this.getNecessaryInfo();

      // Fetch themes for application users when page dashboard is mounted
      try {
        if (this.getAuthenticatedUser?.is_contact) {
          const companyId =
            this.getAuthenticatedUser?.company_id || this.getAuthenticatedUser?.account_data_id;
          if (companyId) {
            this.$store.dispatch('theme/fetchThemes', companyId);
          }
        }
      } catch (themeError) {
        console.warn('Failed to fetch themes in page dashboard:', themeError);
        // Don't fail the dashboard loading if theme fetching fails
      }
    },
    methods: {
      checkUniqueConnectionComponents() {
        const uniqueComponents = new Set();
        const components = this.getSingleDashboardData?.components;
        components.forEach((comp) => {
          if (comp.data_source === 'INTEGRATIONS' && comp.integrationsSettings?.integration_id) {
            uniqueComponents.add(comp.integrationsSettings.integration_id);
          }
        });
        return Array.from(uniqueComponents);
      },

      async getIntegrations() {
        try {
          let configuredConnetions = this.checkUniqueConnectionComponents();
          const connectionInfos = await Promise.allSettled(
            configuredConnetions.map(async (connection_id) => {
              const result = await postAPICall(
                'GET',
                `/integrations/service/get-tokens-by-connection/${connection_id}`
              );
              return result?.data;
            })
          );
          const successfulConnections = connectionInfos
            .filter((result) => result.status === 'fulfilled')
            .map((result) => result.value);
          return successfulConnections || [];
        } catch (err) {
          console.log('Integration-connection-err', err);
        }
      },
      getAllPageDashboards() {
        this.pageDashboards = [];
        if (this.getPageDashboards?.length) {
          this.pageDashboards = this.getPageDashboards;
        }
      },
      changePageDashboard() {
        if (this.isFromApplicationuser) {
          this.$router.push({
            path: `/ap/page-dashboard/${this.activeCustomDashboardId}?key=${Math.floor(
              Math.random() * 100000
            )}&menu_id=${this.$route.query.menu_id}`,
          });
        } else {
          this.$router.push({
            path: `/page-dashboard/${this.activeCustomDashboardId}?key=${Math.floor(
              Math.random() * 100000
            )}&menu_id=${this.$route.query.menu_id}`,
          });
        }
      },
      getNecessaryInfo() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        if (this.$route?.params?.dashboardId) {
          this.dateFilter = false;
          this.fetchDashboard(this.$route?.params?.dashboardId);

          this.getSubscriptionHistory();
        }
      },
      async getSubscriptionHistory() {
        try {
          let email = 'info@esigns.io';
          await this.$store.dispatch('paymentGateway/fetchSubscriptionInfo', {
            email,
          });
        } catch (error) {
          console.log('getSubscriptionHistory', error);
        }
      },
      checkPermissions(entity, permission) {
        if (this.isFromApplicationuser) {
          if (this.permissionsSet && Object.keys(this.permissionsSet).length > 0) {
            if (
              this.permissionsSet[entity] &&
              this.permissionsSet[entity].indexOf(permission) != -1
            ) {
              return true;
            }
            return false;
          }
          return false;
        }
        return true;
      },
      switchPositions(evt) {
        if (
          evt &&
          typeof evt.oldIndex == 'number' &&
          typeof evt.newIndex == 'number' &&
          this.activeCustomDashboard.allTableComponents[evt.oldIndex]
        ) {
          let data = this.activeCustomDashboard.allTableComponents[evt.oldIndex];
          let data1 = this.activeCustomDashboard.allTableComponents[evt.newIndex];
          data.order = evt.newIndex;
          data1.order = evt.oldIndex;
          this.activeCustomDashboard.allTableComponents[evt.oldIndex] = {
            ...data,
          };
          this.activeCustomDashboard.allTableComponents[evt.newIndex] = {
            ...data1,
          };
        }
      },
      expendTable(index) {
        if (this.expendedIndexs.indexOf(index) == -1) {
          this.activeCustomDashboard.allTableComponents[index]['is_expand'] = true;
          this.expendedIndexs.push(index);
        } else {
          this.expendedIndexs.splice(this.expendedIndexs.indexOf(index), 1);
          this.activeCustomDashboard.allTableComponents[index]['is_expand'] = false;
        }
      },

      async fetchDashboard(id) {
        this.loading = true;
        const query = { get_all: true };
        let promises = [];
        promises.push(this.$store.dispatch('customDashboard/getDashboardById', id));
        let [allTemplates, allEntities, globalVariables] = await Promise.all([
          this.fetchAllTemplates(),
          this.fetchAllEntities(),
          fetchGlobalVariables(query),
          ...promises,
        ]);
        let integrations = await this.getIntegrations();
        this.allCompanyTemplatesData = { data: allTemplates };
        this.getAllEntities = { data: allEntities };
        if (integrations) {
          this.integrations = integrations;
        }
        if (this.getEntityPermission?._id) {
          (this.getEntityPermission.other_entities &&
          Object.keys(this.getEntityPermission.other_entities)
            ? Object.keys(this.getEntityPermission.other_entities)
            : []
          ).forEach((entity) => {
            if (!this.permissionsSet[entity]) {
              this.permissionsSet[entity] =
                this.getEntityPermission.other_entities[entity].permissions;
            }
          });
          (this.getEntityPermission.relational_entities &&
          Object.keys(this.getEntityPermission.relational_entities)
            ? Object.keys(this.getEntityPermission.relational_entities)
            : []
          ).forEach((entity) => {
            if (!this.permissionsSet[entity]) {
              this.permissionsSet[entity] =
                this.getEntityPermission.relational_entities[entity].permissions;
            }
          });
        }
        if (globalVariables && globalVariables?.data) {
          this.globalVariablesData = [...globalVariables.data];
        }
        if (this.getSingleDashboardData) {
          this.activeCustomDashboard = {
            name: this.getSingleDashboardData.name,
            includeGlobalDateFilter: this.getSingleDashboardData.include_global_date_filter,
            date_value: this.getSingleDashboardData.date_value,
            Custom_date_value: this.getSingleDashboardData.Custom_date_value,
            allTableComponents: this.getSingleDashboardData.components
              .filter((e) =>
                [
                  'TABLE',
                  'CHART',
                  'CALENDAR',
                  'LOGINS',
                  'ENTITY_VIEW',
                  'GAUGE_CHART',
                  'NOTIFICATIONS',
                  'SCHEDULING',
                ].includes(e.type)
              )
              .sort((a, b) => (a.order < b.order ? -1 : 1)),
            allStatComponents: this.getSingleDashboardData.components
              .filter((e) => e.type == 'STAT')
              .map((e) => {
                if (e?.data_source == 'INTEGRATIONS') {
                  e.dates = {
                    startDate: '',
                    endDate: '',
                  };
                }
                return e;
              }),
            allIntegrationFilters: this.getSingleDashboardData.components
              .filter((e) => e.type == 'INTEGRATION_FILTER')
              .map((e) => {
                if (e?.data_source == 'INTEGRATIONS') {
                  e.dates = {
                    startDate: '',
                    endDate: '',
                  };
                }
                return e;
              }),
            allCustomFilters: this.getSingleDashboardData.components
              .filter((e) => e.type == 'CUSTOM_FILTER')
              .map((e) => {
                e.value = '';
                e.selected_filter = '';
                return e;
              }),
            keyValue: (Math.random() + 1).toString(36).substring(7),
            allowUserChangeOrder: this.getSingleDashboardData.allow_user_change_order,
          };
          const allEntities = [
            ...this.activeCustomDashboard.allTableComponents.flatMap((e) => e.entity_id),
            ...this.activeCustomDashboard.allStatComponents.flatMap((e) => e.entity_id),
            ...this.activeCustomDashboard.allCustomFilters.flatMap((e) => e.entity_id),
          ];
          this.activeCustomDashboard.allCustomFilters =
            this.activeCustomDashboard.allCustomFilters.filter(
              (e) => allEntities.indexOf(e.entity_id) !== -1
            );
          this.activeCustomDashboard.allTableComponents =
            this.activeCustomDashboard.allTableComponents.map((e) => {
              e.keyValue = (Math.random() + 1).toString(36).substring(7);
              return e;
            });
          this.activeCustomDashboard.allStatComponents =
            this.activeCustomDashboard.allStatComponents.map((e) => {
              return e;
            });
          this.activeCustomDashboard.allCustomFilters =
            this.activeCustomDashboard.allCustomFilters.map((e) => {
              e.keyValue = (Math.random() + 1).toString(36).substring(7);
              return e;
            });
          this.activeCustomDashboard.allTableComponents.forEach((el, i) => {
            if (el.is_expand) {
              this.expendedIndexs.push(i);
            }
          });
        }
        this.loading = false;
      },
      DateFilterUpdate() {
        this.dateFilter = true;
      },
      changeDashboard(tab) {
        this.refresh = true;
        this.dateFilter = false;
        this.changeCustomDashboard(tab.index);
      },
      async updateCsutomDashboard(component) {
        try {
          if (component.type === 'STAT') {
            let statComponets = this.activeCustomDashboard.allStatComponents;
            statComponets.forEach((stat, index) => {
              if (stat.keyValue === component.keyValue) {
                this.activeCustomDashboard.allStatComponents[index] = component;
              }
            });
          } else {
            let tableComponents = this.activeCustomDashboard.allTableComponents;
            tableComponents.forEach((comp, index) => {
              if (comp.keyValue === component.keyValue) {
                this.activeCustomDashboard.allTableComponents[index] = component;
              }
            });
          }
          let params = {
            name: this.activeCustomDashboard.name,
            components: [
              ...(this.activeCustomDashboard.allStatComponents || []),
              ...(this.activeCustomDashboard.allTableComponents || []),
              ...(this.activeCustomDashboard.allCustomFilters || []),
              ...(this.activeCustomDashboard?.allMulCustomFilters || []),
            ],
            include_global_date_filter: this.activeCustomDashboard.includeGlobalDateFilter,
            date_value: this.activeCustomDashboard.date_value,
            Custom_date_value: this.activeCustomDashboard.Custom_date_value,
            allow_user_change_order: this.activeCustomDashboard.allowUserChangeOrder,
          };
          await this.$store.dispatch('customDashboard/updateDashboard', {
            id: this.$route.params.dashboardId,
            params: params,
          });
          if (this.getUpdateDashboardStatus) {
            if (this.getUpdateDashboardData?.data) {
              await updateCustomDashboardData(
                this.$route.params.dashboardId,
                this.getUpdateDashboardData.data
              );
            }
            this.$notify({
              title: 'Success',
              message: 'Dashboard updated successfully',
              type: 'success',
            });
          } else {
            let msg =
              this.getUpdateDashboardError && this.getUpdateDashboardError.message
                ? this.getUpdateDashboardError.message
                : 'Error while editing dashboard';
            this.$notify({
              title: 'Error',
              message: msg,
              type: 'error',
            });
          }
        } catch (err) {
          let msg = err.message ? err.message : 'Error while updating dashboard';
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
    },
    watch: {
      '$route.params.dashboardId'() {
        this.dateFilter = false;
        this.getAllPageDashboards();
        this.getNecessaryInfo();
      },
      '$route.query.menu_id'() {
        if (this.currentMenuId !== this.$route.query.menu_id) {
          this.dateFilter = false;
          this.getAllPageDashboards();
          this.getNecessaryInfo();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .scrollbar {
    &::-webkit-scrollbar {
      border-radius: 10px;
      height: 10px;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
    }
  }
  .el-tabs__item.is-active {
    border-bottom: 2px solid var(--brand-500) !important;
    color: var(--primary-color-brand) !important;
  }

  .dashboard-filters {
    position: relative;
  }

  .icon-search {
    margin-top: 8px;
    position: absolute;
    right: 20px;
    width: 17%;
    transform: translateY(-50%);
  }

  .wrapper-grid {
    width: 100%;
    min-height: auto;
  }

  .dashboard {
    overflow: hidden;
    min-height: auto;

    .stats-container {
      padding-bottom: 16px;
      gap: 30px;

      .card {
        margin-right: 5px;
        width: 165px;
        height: 69px;
        border-radius: 10px;
        min-width: 170px;

        cursor: pointer;
        border-color: #e3eafd;

        &:hover {
          background-color: #f4f7ff;
        }

        &.active {
          background-color: #ebeffd;
          border-color: #d2dcfa;
        }
      }

      .latest-updates {
        font-size: 0.85em;
      }
    }

    .icon-block {
      display: flex;
      gap: 10px;

      .icon-file {
        max-width: 20px;
        display: inline;
      }
    }

    .search {
      border-radius: 5px;
      border: none !important;
    }

    .vue-data-table-default {
      .title {
        letter-spacing: 0.019em;
      }

      .circle {
        position: relative;
        padding-left: 20px;
        text-transform: capitalize;
        font-size: 14px;

        &::after {
          content: '';
          position: absolute;
          top: 4px;
          left: 0;
          height: 10px;
          width: 10px;
          display: inline-block;
          border-radius: 50%;
        }

        &.completed::after {
          background: #08ad36;
        }

        &.draft::after {
          background: #f19203;
        }

        &.sent::after {
          background: #2f80ed;
        }

        &.active::after {
          background: #635e5e;
        }
      }
    }

    .notification-box {
      .list-group-flush > .list-group-item {
        border-width: 0 0 1px;
      }

      .noNotifications {
        margin-left: 40%;
        display: grid;
        gap: 0px;

        .img-text {
          margin-left: 5px;
          color: #1f1f1f;
        }
      }

      .notifcation-item {
        cursor: pointer;
        padding: 0;
        display: grid;
        grid-template-columns: 2.75em 1fr;
        gap: 15px;
        padding: 10px 0;

        .item-avatar {
          border-radius: 50%;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid var(--brand-500);
          background-color: rgba(#f754a2, $alpha: 0.1);
          color: var(--brand-500);
        }

        .item-body {
          .name {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .Title_sty {
    font-size: 12px;
    margin-left: -13px;
    margin-top: -10px;
  }

  .imgstyle {
    width: 25%;
    margin-left: 100px;
    margin-top: -10px;

    @media (max-width: 399.98px) {
      width: 36px;
      margin-top: -9px;
    }
  }

  .number_sty {
    margin-top: -28px;
    margin-left: -2px;
  }

  .drag-grid {
    display: flex !important;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 25px;
    min-height: auto;
  }

  .drag-grid .grid-item {
    width: calc(50% - 6px);
  }

  .drag-grid .grid-item.full-span {
    width: 100% !important;
  }

  .wrapper-grid {
    position: relative;
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    scrollbar-width: thin;
  }

  .hr {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }

  .select-company_type {
    margin-top: -8px;
    width: 40%;
  }

  .dashboard-cards {
    display: flex;
    gap: 5px;
    font-weight: 500;
    margin-bottom: 16px;

    @media (max-width: 400px) {
      align-items: flex-end !important;
    }
  }

  .dashboard-card {
    cursor: pointer;
    transition:
      transform 0.2s ease,
      background-color 0.2s ease,
      color 0.2s ease;
    text-align: center;
    border: none;
    background-color: transparent;
    color: var(--black-960);
    border-bottom: 1px solid transparent;
  }

  .dashboard-card .el-card__body {
    padding: 0 !important;
  }

  .dashboard-card.is-active {
    color: var(--brand-500);
    transform: scale(1.05);
    border-bottom: 2px solid var(--brand-500);
  }

  .dashboard-card:hover {
    background-color: var(--brand-500);
    color: var(--brand-500);
  }

  .drag-grid > div {
    transform: none !important;
  }

  @media (max-width: 360px) {
    .Greeting h2 {
      font-size: 1rem !important;
    }

    .dashboard-card {
      font-size: 10px;
      height: 25px;
    }

    .stats-container {
      flex-direction: column;
    }

    .dashboard-top-buttons {
      width: 100% !important;
      max-width: 100%;
    }

    .el-button--mini {
      font-size: 8px;
      border-radius: 3px;
    }

    .el-button--mini,
    .el-button--mini.is-round {
      padding: 4px 12px;
    }
  }
</style>
